/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useCallback, useEffect, useMemo } from 'react';
import dynamic from 'next/dynamic';
import { useFormikContext } from 'formik';
import { styled } from 'linaria/react';
import { debounce } from 'lodash';
import { useIsDvoinoiShansNaPobeduActive } from '@views/news-page/lib/useIsDvoinoiShansNaPobeduActive';
import { useIsOsenniiRozygryshPrizov2026Active } from '@views/news-page/lib/useIsOsenniiRozygryshPrizov2026Active';
import { useCyberStore } from '@entities/tsp';
import { PaymentFormValues } from '@entities/payment';
import { Partners, usePartner } from '@shared/lib/partner';
import OldSteamLoginField from './OldSteamLoginField';
import SteamUserAmountField from './SteamUserAmountField';
import OldSteamFinalAccountAmount from './OldSteamFinalAccountAmount';
import { FocusError } from '../lib/FocusError';
interface Props {
  getCommissions: (baseAmount: number) => void;
}
const DynamicSteamPromoCodeField = dynamic(() => import('./SteamPromoCodeField').then(imported => imported.default), {
  loading: () => <div />,
  ssr: true
});
const DynamicDvoinoiShansNaPobeduBanner = dynamic(() => import('@views/news-page/ui/dvoinoi-shans-na-pobedu/DvoinoiShansNaPobeduBanner').then(imported => imported.default), {
  loading: () => <div />,
  ssr: false
});
const DynamicOsenniiRozygryshPrizov2026Banner = dynamic(() => import('@views/news-page/ui/osennii-rozygrysh-prizov-2026/OsenniiRozygryshPrizov2026Banner').then(imported => imported.default), {
  loading: () => <div />,
  ssr: false
});
const SteamFields: FC<Props> = ({
  getCommissions
}) => {
  const {
    activeService,
    paymentMethod,
    amountInfo
  } = useCyberStore();
  const {
    values,
    errors
  } = useFormikContext<PaymentFormValues>();
  const {
    partner
  } = usePartner();
  const debouncedGetCommission = useCallback(debounce((price: string) => {
    if (price) {
      getCommissions(Number(price));
    }
  }, 500, {
    leading: false,
    trailing: true
  }), [paymentMethod, values, errors]);
  const {
    isPromoActive
  } = useIsDvoinoiShansNaPobeduActive();
  const {
    isPromoActive: isOsenniiPromoActive
  } = useIsOsenniiRozygryshPrizov2026Active();
  useEffect(() => {
    if (amountInfo) {
      debouncedGetCommission(values?.price);
    } else {
      getCommissions(Number(values?.price));
    }
  }, [values?.price]);
  return <Wrapper>
      {/* @ts-ignore */}
      <OldSteamLoginField activeService={activeService} getCommissions={getCommissions} />
      <AmountFieldsWrapper>
        <WrapperField>
          {/* @ts-ignore */}
          <SteamUserAmountField activeService={activeService} />
        </WrapperField>
        <WrapperField>
          <OldSteamFinalAccountAmount />
        </WrapperField>
      </AmountFieldsWrapper>
      {partner === Partners.DEFAULT && <DynamicSteamPromoCodeField getCommissions={getCommissions} />}
      {/* {partner === Partners.DEFAULT && isPromoActive && <DynamicDvoinoiShansNaPobeduBanner />} */}
      {partner === Partners.DEFAULT && isOsenniiPromoActive && <DynamicOsenniiRozygryshPrizov2026Banner />}
      <FocusError />
    </Wrapper>;
};
export default SteamFields;
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w989eys",
  propsAsIs: false
});
const AmountFieldsWrapper = /*#__PURE__*/styled('div')({
  name: "AmountFieldsWrapper",
  class: "au7fy5s",
  propsAsIs: false
});
const WrapperField = /*#__PURE__*/styled('div')({
  name: "WrapperField",
  class: "wex262",
  propsAsIs: false
});

require("./SteamFields.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./SteamFields.tsx");